import { ChargeSplitMode } from "../enum/charge-split-mode.enum";
const toSatang = (n) => Math.round(n * 100) / 100;
/**
 * Go dutch: the whole bill divides equally, claims are ignored. Friends get a
 * whole-baht share rounded down; the owner absorbs the remainder.
 */
function computeGoDutchShares(personIds, items, charges, ownerId) {
    const total = toSatang(items.reduce((s, i) => s + i.amount, 0) + charges.reduce((s, c) => s + c.amount, 0));
    const each = Math.max(0, Math.floor(total / personIds.length));
    const friendsTotal = each * personIds.filter((id) => id !== ownerId).length;
    const shares = personIds.map((personId) => {
        const rounded = personId === ownerId ? Math.max(0, Math.round(total - friendsTotal)) : each;
        return {
            personId,
            itemSubtotal: toSatang(total / personIds.length),
            chargeShare: 0,
            exact: toSatang(total / personIds.length),
            rounded,
        };
    });
    return { shares, unclaimedItemIds: [] };
}
/**
 * Split a bill across people. An item is divided equally among its claimers.
 * A PROPORTIONAL charge follows each person's item subtotal, an EQUAL charge
 * is divided evenly across everyone in the bill.
 */
export function computeBillShares(personIds, items, charges, goDutch) {
    if (goDutch)
        return computeGoDutchShares(personIds, items, charges, goDutch.ownerId);
    const subtotal = new Map(personIds.map((id) => [id, 0]));
    const unclaimedItemIds = [];
    for (const item of items) {
        const claimers = item.claimedBy.filter((id) => subtotal.has(id));
        if (claimers.length === 0) {
            unclaimedItemIds.push(item.id);
            continue;
        }
        const each = item.amount / claimers.length;
        for (const id of claimers)
            subtotal.set(id, subtotal.get(id) + each);
    }
    const claimedTotal = [...subtotal.values()].reduce((s, v) => s + v, 0);
    const chargeShare = new Map(personIds.map((id) => [id, 0]));
    for (const charge of charges) {
        for (const id of personIds) {
            const portion = charge.splitMode === ChargeSplitMode.Proportional && claimedTotal > 0
                ? (charge.amount * subtotal.get(id)) / claimedTotal
                : charge.amount / personIds.length;
            chargeShare.set(id, chargeShare.get(id) + portion);
        }
    }
    const shares = personIds.map((personId) => {
        const itemSubtotal = subtotal.get(personId);
        const charge = chargeShare.get(personId);
        const exact = toSatang(itemSubtotal + charge);
        return {
            personId,
            itemSubtotal: toSatang(itemSubtotal),
            chargeShare: toSatang(charge),
            exact,
            rounded: Math.max(0, Math.round(exact)),
        };
    });
    return { shares, unclaimedItemIds };
}
//# sourceMappingURL=bill-shares.js.map